import React, { useState } from 'react'
import { NewVideoPlayer } from '../../MainEvents/RecommendEventVideos/styles';
import Thumbnail from '../../Thumbnail';
import PropTypes from "prop-types";
import { ImageUrl } from '../../../utils/constants';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
// import { FavouriteIcon } from '../../../utils/icons';
// import { Circle, CircleContainerNew, Tick } from '../../Journeys/styles';
import { RelatedCard, RelatedCardContainer } from '../../VideoArticle/styles';

const RecipesRelatedContent = ({video,history,/*onClickFavoriteRibbon,*/ margin}) => {

  const [onHover, setOnHover]=useState({});

  const onEnterMouse = (id) => {
    setOnHover(id)
  }

  const onLeaveMouse = () => {
    setOnHover(-1)
  };


  return (
    <>
      <RelatedCardContainer margin={margin}>
        <RelatedCard 
          onMouseEnter={() => onEnterMouse(video.id)}
          onMouseLeave={() => onLeaveMouse()}
        >
          <NewVideoPlayer height={'218px'}>
            <Thumbnail
              style={{ cursor: 'default' }} 
              src={`${ImageUrl}/${video?.recipe_image || video?.image}`}
              alt={'img'}
              height={'218px'}
            />
          </NewVideoPlayer>
          {onHover === video.id &&
              <div className='educateImageBackground' onClick={()=>history.push(`/wellness-resources/recipe-details/${video.id}`)}>
                <div className="getStarted">
                  {/* {LaunchIcon()} */}
                  {("Start Cooking")}
                </div>
              </div>
          }
          <div className='details'>
            <div className='name' title={video?.name || video?.title}>
              {t(video?.name || video?.title)}
            </div>
  
            {/* <div className='left-col'>
              <div title={video?.name}>
                <CircleContainerNew style={{ "marginLeft": "15px",marginRight:'20px' }}>
                  <div className="flex">
                    <Circle borderColor="#DA6C74" checked={video?.['view_status']} width={'20px'} height={'20px'} borderWidth={'1px'}>
                      <Tick checked={video?.['view_status']} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                    </Circle>
                  </div>
                  <div className="quiz">
                    {t("Watched")}
                  </div>
                </CircleContainerNew> 
              </div>
              <div style={{cursor:'pointer', display:'flex'}} title={video?.title} onClick={() => {
                onClickFavoriteRibbon(
                  "recipe",
                  video.id,
                  video?.like_status,
                  video?.favorite_status ? 0 : 1,
                  0
                );
                // this.saveImage();
              }}>
                {<FavouriteIcon fill={video?.favorite_status? "#DA6C74" : "none"}/>}
              </div>
            </div> */}
          </div>
        </RelatedCard>
      </RelatedCardContainer>
    </>
  )
}

RecipesRelatedContent.propTypes = {
  video: PropTypes.object,
  showDescription: PropTypes.bool,
  history: PropTypes.object.isRequired,
  grid: PropTypes.number,
  link: PropTypes.string,
  margin: PropTypes.string,
  bottom: PropTypes.string,
  width: PropTypes.string,
  onClickFavoriteRibbon: PropTypes.func,
  t: PropTypes.func,
};
  
export default (withTranslation()(RecipesRelatedContent));